import React from 'react'
import { map as _map, values as _values } from 'lodash'

import { Tooltip  } from 'components'
import { ArrayHandler, LabDataHandler, NumberHandler } from 'utils'


const displayList = (display, fibonacciValue) => {
	const displayData = ArrayHandler.sorter(_values(display), 'Order');

	let displayLength = Object.keys(display).length;

	if (fibonacciValue) {
		displayData.splice(1, 1);
		fibonacciValue.map((item) => (displayData.push(item)));

		displayLength = displayData.length;
	}

	return _map(displayData, (item, idx) => {
		const lgColoum = (displayLength !== 12 && displayLength !== 6
					&& !(12 % displayLength)) ? 12 / displayLength : 3;
		const smColoum = (lgColoum > 3) ? 12 : 6;
		const parsedFigure = ('Data' in item && item.Data !== null)
			? ((Number(item.Data) === item.Data)
				? NumberHandler.comma(item.Data)
				: item.Data)
			: '';
		const title = (item.UnitRef === '')
			? item.ChineseAccount.split('(')[0]
			: item.ChineseAccount;
		const hasUnit = item.ChineseAccount.match(/[^()]+\(([^()]+)\)$/);
		const unit = (item.UnitRef === '')
			? hasUnit ? '(' + hasUnit[1] + ')' : ''
			: item.UnitRef;
		const explanations = LabDataHandler.getExplanationData([ item ]);

		return (displayLength
			? (
				<div
					className={`summary-table-element col-sm-${smColoum}
							col-md-6 col-lg-${lgColoum}`}
					key={idx}
				>
					<div className='summary-table-text'>
						<div>{title}</div>

						{explanations.map((item, idx) => (
							<Tooltip
								id={item.name}
								containerClass='component-header-icon cursor-pointer'
								content={
									<div className='explanation-tooltip ua-tooltip ua-box default'>
										<h3 className='txt-normal'>{item.name}</h3>

										{(item.text.length > 0) && (
											<div className='text-justify'>{item.text}</div>
										)}
									</div>
								}
								key={idx}
							/>
						))}

					</div>

					<div
						className='summary-table-value'
						style={{ fontSize: (parsedFigure.length > 10) ? 14 : 18 }}
					>
						{(parsedFigure !== '') ? parsedFigure : '-'}
						&nbsp;
						{(parsedFigure !== '') ? item.UnitRef ? item.UnitRef : unit : null}
					</div>
				</div>
			)
			: null
		);
  });
}

const Display = ({ display, fibonacciValue }) => (display
	? (
		<div className='summary'>
			<div className='summary-table row'>
				{displayList(display, fibonacciValue)}
			</div>
		</div>
	)
	: null
);


export { Display }
